import React, { ReactNode } from "react";
import { Colors } from "../../Constants/colors";
import { Button } from "../Button";
import {
  ALIGN_ITEMS,
  DISPLAY,
  FLEX_DIRECTION,
  SPACING,
} from "../../Constants/Enums/styles.enum";
import { FontFamily } from "../../Constants/Enums/FontFamily.enums";
import { useMobile } from "../../hooks/deviceHooks/useDevice.hooks";

interface FilterBarProps {
  children: ReactNode;
  onSearch: () => void;
  onClear?: () => void;
  isLoading?: boolean;
  showClearButton?: boolean;
}

export const FilterBar = ({
  children,
  onSearch,
  onClear,
  isLoading = false,
  showClearButton = true,
}: FilterBarProps) => {
  const isMobile = useMobile();

  return (
    <div
      style={{
        display: DISPLAY.FLEX,
        flexDirection: isMobile ? FLEX_DIRECTION.COLUMN : FLEX_DIRECTION.ROW,
        gap: SPACING.S16,
        padding: `${SPACING.S16} ${SPACING.S20}`,
        backgroundColor: Colors.White,
        borderRadius: "12px",
        border: `1px solid ${Colors.LightGrey}`,
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
        marginBottom: SPACING.S20,
        flexWrap: "wrap",
        alignItems: isMobile ? ALIGN_ITEMS.START : ALIGN_ITEMS.END,
      }}
    >
      {/* Filter inputs container */}
      <div
        style={{
          display: DISPLAY.FLEX,
          flexDirection: FLEX_DIRECTION.ROW,
          gap: SPACING.S12,
          flex: 1,
          flexWrap: "wrap",
          alignItems: ALIGN_ITEMS.END,
        }}
      >
        {children}
      </div>

      {/* Action buttons */}
      <div
        style={{
          display: DISPLAY.FLEX,
          flexDirection: FLEX_DIRECTION.ROW,
          gap: SPACING.S12,
          alignItems: ALIGN_ITEMS.CENTER,
        }}
      >
        {showClearButton && onClear && (
          <button
            onClick={onClear}
            style={{
              padding: `${SPACING.S10} ${SPACING.S20}`,
              backgroundColor: Colors.White,
              border: `2px solid ${Colors.LightGrey}`,
              borderRadius: "8px",
              cursor: "pointer",
              fontFamily: FontFamily.POPPINS_REGULAR,
              fontSize: "14px",
              color: Colors.Grey,
              fontWeight: "500",
              transition: "all 0.2s ease",
              display: DISPLAY.FLEX,
              alignItems: ALIGN_ITEMS.CENTER,
              gap: SPACING.S8,
              height: "48px",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = Colors.VeryLightGrey;
              e.currentTarget.style.borderColor = Colors.Grey;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = Colors.White;
              e.currentTarget.style.borderColor = Colors.LightGrey;
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                fill="currentColor"
              />
            </svg>
            Clear
          </button>
        )}
        <Button
          loading={isLoading}
          text="Search"
          onClick={onSearch}
          btnStyle={{
            height: "48px",
            padding: `${SPACING.S10} ${SPACING.S24}`,
          }}
        />
      </div>
    </div>
  );
};
